<template>
  <div v-if="getPaymentFrameData.show" class="popup">
    <div class="popup__container">
      <header class="popup__header">
        <h3 class="popup__title">{{ getHeaderText }}</h3>
        <div class="popup__header-button">
          <div class="close" @click.prevent="closePaymentFrame"></div>
        </div>
      </header>
      <div class="popup__content">
        <div v-if="is_show_message" class="payment-iframe__inner">
          <MycomPaymentMessage :messageType="message_type"></MycomPaymentMessage>
        </div>

        <iframe
          v-else
          class="payment-iframe js-payment-frame"
          height="440"
          width="100%"
          border="0"
          :src="getPaymentFrameData.url"
        ></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import MycomPaymentMessage from "./MycomPaymentMessage";
export default {
  name: "PurchaseMyComFrame",
  components: {
    MycomPaymentMessage,
  },
  props: {
    frameType: String, // points, premium
  },
  data() {
    return {
      is_show_message: false,
      message_type: null,
    };
  },
  computed: {
    ...mapGetters("billing", ["getPaymentFrameData"]),
    getHeaderText() {
      return this.frameType === "points"
        ? this.$t("points.header")
        : this.$t("access_popup.header_text");
    },
  },

  mounted() {
    window.addEventListener("message", this.updatePaymentStatus);
  },

  beforeDestroy() {
    window.removeEventListener("message", this.updatePaymentStatus);
  },

  methods: {
    updatePaymentStatus(event) {
      let data = JSON.parse(event.data);

      if (event.origin !== "https://pw.money.mail.ru") {
        return false;
      } else {
        if (data.action === "paySuccess") {
          this.is_show_message = true;
          this.message_type = "success";
        }
        if (data.action === "payError") {
          this.is_show_message = true;
          this.message_type = "error";
        }
      }
    },
    closePaymentFrame() {
      this.$store.commit("billing/updatePaymentFrameState", {
        show: false,
        url: null,
      });
    },
  },
};
</script>
